import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import RankingExportadoresView from '../../components/controlExistencias/RankingExportadoresView'
import { obtenerRankingExportadores } from '../../actions/listados'

function RankingExportadores (props) {
  const { obtenerRankingExportadores } = props

  useEffect(() => {
    obtenerRankingExportadores()
  }, [obtenerRankingExportadores])

  return (
    <RankingExportadoresView />
  )
}

const mapActionsToProps = {
  obtenerRankingExportadores
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(RankingExportadores)
